import { render, staticRenderFns } from "./charts.pug?vue&type=template&id=6f171029&lang=pug&"
import script from "./charts.js?vue&type=script&lang=js&"
export * from "./charts.js?vue&type=script&lang=js&"
import style0 from "./charts.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f171029')) {
      api.createRecord('6f171029', component.options)
    } else {
      api.reload('6f171029', component.options)
    }
    module.hot.accept("./charts.pug?vue&type=template&id=6f171029&lang=pug&", function () {
      api.rerender('6f171029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/charts/index.vue"
export default component.exports